// Catches and displays React runtime errors.
import { Component } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { translate as t } from '@/i18n/useT';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to the console for debugging purposes
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            p: 8,
            textAlign: 'center',
          }}
        >
          <Typography variant="h2" component="h2">
            {t('errorboundary.title', 'Oops! Something went wrong.')}
          </Typography>
          <Typography
            sx={{
              color: 'text.secondary',
              mb: 6,
            }}
          >
            {t(
              'errorboundary.description',
              'An unexpected error occurred in the application.',
            )}
          </Typography>
          <Button
            onClick={() => (window.location.href = '/')}
            sx={{
              backgroundColor: 'secondary.main',
              color: '#ffffff',
              '&:hover': {
                backgroundColor: 'secondary.dark',
              },
            }}
          >
            {t('errorboundary.reload', 'Reload application')}
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
